import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { CONTENT_TOP_OFFSET } from '../../theme/tokens';

/**
 * PageLoading — Suspense fallback while a module chunk loads (code splitting).
 * Offset below the fixed AppBar so the spinner doesn't hide under it.
 */
const PageLoading = () => (
    <Box
        sx={{
            pt: `${CONTENT_TOP_OFFSET + 48}px`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1.5,
        }}
    >
        <CircularProgress size={32} />
        <Typography variant="caption" color="text.secondary">
            Loading…
        </Typography>
    </Box>
);

export default PageLoading;
